<template>
  <div class="cms-rows-per-page">
    <label class="cms-rows-per-page-label">{{ $t('general.shared.tableShowNumber', { number: selected }) }}</label>
    <select
      :id="id"
      :value="selected"
      class="cms-select cms-select-sm"
      @change="handleChange"
    >
      <option v-for="option in options" :key="option" :value="option">
        {{ option }}
      </option>
    </select>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

interface Props {
  id?: string;
  selected: number;
  options?: number[];
}

const props = withDefaults(defineProps<Props>(), {
  options: () => [10, 25, 50, 100],
});

const emit = defineEmits<{
  (e: 'changed', value: number): void;
}>();

const { t } = useI18n();

const handleChange = (event: Event) => {
  const target = event.target as HTMLSelectElement;
  const value = parseInt(target.value, 10);
  emit('changed', value);
};
</script>

<style lang="scss" scoped>
@import './cms-styles.scss';

.cms-rows-per-page {
  display: flex;
  align-items: center;
  gap: $cms-spacing-sm;
}

.cms-rows-per-page-label {
  font-size: $cms-font-size-sm;
  color: $cms-text-secondary;
  white-space: nowrap;
}

.cms-select-sm {
  width: auto;
  min-width: 80px;
  padding: $cms-spacing-xs $cms-spacing-sm;
  font-size: $cms-font-size-sm;
}
</style>

